import { getAdderTypeLabel } from '@/helpers/addersHelpers';
import { Box } from '@palmetto/palmetto-components';

import { AdderType, DIFF_IDENTITY_KEY } from 'types';

import { Diffs } from './Diffs';
import EventBy from './EventBy';

const hiddenProperties = ['currentMilestone', 'requirements', 'milestones'];

const asRecord = (value: unknown): Record<string, unknown> | undefined =>
  value !== null && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : undefined;

// The backend identifies an adder by `type:model`, or by type alone when it has no model.
const formatIdentity = (identity: string): string => {
  const separator = identity.indexOf(':');
  const type = (separator === -1 ? identity : identity.slice(0, separator)) as AdderType;
  const model = separator === -1 ? '' : identity.slice(separator + 1);
  const typeLabel = getAdderTypeLabel(type) ?? type;
  return model ? `${typeLabel} (${model})` : typeLabel;
};

// The diff is `{ adders: [...] }`, where each element carries the identity marker from the
// backend's identity-based array matching. Label the changed adders from that.
const getLabel = (diff: unknown): string => {
  const addersDiff = asRecord(diff)?.adders;
  if (!Array.isArray(addersDiff)) {
    return '';
  }
  return addersDiff
    .map((element) => asRecord(element)?.[DIFF_IDENTITY_KEY])
    .filter((identity): identity is string => typeof identity === 'string' && identity.length > 0)
    .map(formatIdentity)
    .join(',');
};

const SabalAddersUpdated = ({ event }: { event: any }) => {
  const foundLabel = getLabel(event?.data?.diff);
  const label = `${foundLabel ? `${foundLabel} ` : ''}Adder`.trim();
  return (
    <Box display="block">
      <EventBy event={event} /> updated
      <br />
      <strong>{label || ''}</strong>
      {label ? <br /> : null}
      <Diffs diff={event?.data?.diff} hiddenProperties={hiddenProperties} hideInitialNulls />
    </Box>
  );
};

export default SabalAddersUpdated;
